import React, {useState} from "react";
import {TourMembership} from "../../models/membership";
import {useTranslation} from "react-i18next";
import {Tour} from "../../models/tour";
import {TourMembershipDialog} from "../dialogs/TourMembershipDialog";
import {EmergencyContact} from "../../models/emergencyContact";
import {formatDateTime} from "../../utils/formatDateTime";
import {FiFlag, FiPlay} from "react-icons/fi";

interface FoundTourProps {
    tour: Tour;
    accountEmergencyContacts: EmergencyContact[];
    tourMemberships: TourMembership[];
    onReloadTours: () => void;
    onCloseSearch: () => void;
}

export default function FoundTour({
                                      tour,
                                      accountEmergencyContacts,
                                      onReloadTours,
                                      tourMemberships,
                                      onCloseSearch
                                  }: FoundTourProps) {

    const {t} = useTranslation();

    const [showJoinDialog, setShowJoinDialog] = useState(false);

    const disableJoinButton = tourMemberships.map(m => m.tour.id).includes(tour.id);

    function handleJoin() {
        setShowJoinDialog(true);
    }

    function savedMembership() {
        onReloadTours();
        handleClose();
    }

    function handleClose() {
        setShowJoinDialog(false);
        onCloseSearch();
    }

    return (
        <div className="search-result">

            <div className="search-result-left">
                <div className="search-result-title">
                    {tour.destination}
                </div>

                <div className="search-result-subtitle">
                    <FiPlay/> {formatDateTime(tour.validFrom)}
                </div>

                <div className="search-result-subtitle">
                    <FiFlag/> {formatDateTime(tour.validTo)}
                </div>

                <div className="search-result-badge">
                    {tour.tourCode}
                </div>
            </div>

            <div className="search-result-right">
                <button
                    className="form-button search-result-button"
                    disabled={disableJoinButton}
                    onClick={handleJoin}
                >
                    {t("tours.buttons.join")}
                </button>
            </div>

            {showJoinDialog && (
                <TourMembershipDialog
                    tour={tour}
                    accountEmergencyContacts={accountEmergencyContacts}
                    onClose={handleClose}
                    onSaved={savedMembership}
                />
            )}
        </div>
    );
}